/**
 * This file defines all of the roles and permissions for different
 * kinds of users and resources on the platform.
 */

// Add new permissions here with format '{resource}:{action}'
const PermissionType = {
  QUESTION_PUBLISH: 'question:publish',
  QUESTION_EDIT: 'question:edit',
  QUESTION_PIN: 'question:pin',
  QUESTION_ARCHIVE: 'question:archive',
  GRANT_ACCESS: 'access:grant',
  REFERRERS_EDIT: 'referrers:edit',
  COACHING_CREDITS_EDIT: 'coaching_credits:edit',
  DUET_CREDITS_EDIT: 'duet_credits:edit',
  USER_EDIT: 'user:edit',
};

const Roles = {
  ADMIN: 'admin',
  MODERATOR: 'moderator',
  DEFAULT: 'default',
};

const Permissions = {
  [Roles.ADMIN]: {
    [PermissionType.QUESTION_PUBLISH]: true,
    [PermissionType.QUESTION_EDIT]: true,
    [PermissionType.QUESTION_PIN]: true,
    [PermissionType.QUESTION_ARCHIVE]: true,
    [PermissionType.GRANT_ACCESS]: true,
    [PermissionType.REFERRERS_EDIT]: true,
    [PermissionType.COACHING_CREDITS_EDIT]: true,
    [PermissionType.DUET_CREDITS_EDIT]: true,
    [PermissionType.USER_EDIT]: true,
  },
  [Roles.MODERATOR]: {
    [PermissionType.QUESTION_PUBLISH]: true,
    [PermissionType.QUESTION_EDIT]: true,
    [PermissionType.QUESTION_PIN]: true,
    [PermissionType.QUESTION_ARCHIVE]: true,
    [PermissionType.REFERRERS_EDIT]: true,
  },
  [Roles.DEFAULT]: {},
};

module.exports = {
  Permissions,
  PermissionType,
  Roles,
};
